import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Save, Plus, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ICONS = ["Truck", "ShoppingCart", "Building", "PackageSearch", "Store", "Users", "Briefcase", "Heart", "Utensils", "GraduationCap"];

const SectorsEditor = ({ content, onSave }) => {
  const [formData, setFormData] = useState({
    section_label: "",
    title: "",
    subtitle: "",
    sectors: []
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (content) {
      setFormData(content);
    }
  }, [content]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSectorChange = (index, field, value) => {
    const updated = [...formData.sectors];
    updated[index] = { ...updated[index], [field]: value };
    setFormData({ ...formData, sectors: updated });
  };

  const addSector = () => {
    const newSector = {
      id: `sector-${Date.now()}`,
      icon: "Building",
      title: "Nuevo Sector",
      description: "Descripción del sector",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800"
    };
    setFormData({ ...formData, sectors: [...formData.sectors, newSector] });
  };

  const removeSector = (index) => {
    const updated = formData.sectors.filter((_, i) => i !== index);
    setFormData({ ...formData, sectors: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const success = await onSave(formData);
    setSaving(false);
    if (success) {
      toast.success("Sectores actualizados correctamente");
    } else {
      toast.error("Error al guardar los cambios");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="sectors-editor"
    >
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Editar Sectores</h1>
          <p className="text-[#94a3b8]">Administra los sectores que atiendes</p>
        </div>
        <button onClick={addSector} className="btn-secondary flex items-center gap-2">
          <Plus className="w-5 h-5" />
          <span>Agregar Sector</span>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="glass-card p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Textos de la Sección</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Etiqueta</label>
              <input type="text" name="section_label" value={formData.section_label} onChange={handleChange} className="contact-input w-full" />
            </div>
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Título</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} className="contact-input w-full" />
            </div>
          </div>
          <div className="mt-4">
            <label className="block text-[#94a3b8] text-sm mb-2">Subtítulo</label>
            <textarea name="subtitle" value={formData.subtitle} onChange={handleChange} rows={2} className="contact-input w-full resize-none" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {formData.sectors.map((sector, index) => (
            <div key={sector.id} className="glass-card p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-white font-medium">Sector {index + 1}</h3>
                <button type="button" onClick={() => removeSector(index)} className="p-1 text-red-400 hover:bg-red-500/10 rounded">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-[#94a3b8] text-sm mb-2">Título</label>
                  <input type="text" value={sector.title} onChange={(e) => handleSectorChange(index, "title", e.target.value)} className="contact-input w-full" />
                </div>
                <div>
                  <label className="block text-[#94a3b8] text-sm mb-2">Icono</label>
                  <select value={sector.icon} onChange={(e) => handleSectorChange(index, "icon", e.target.value)} className="contact-input w-full">
                    {ICONS.map(icon => (<option key={icon} value={icon}>{icon}</option>))}
                  </select>
                </div>
                <div>
                  <label className="block text-[#94a3b8] text-sm mb-2">Descripción</label>
                  <input type="text" value={sector.description} onChange={(e) => handleSectorChange(index, "description", e.target.value)} className="contact-input w-full" />
                </div>
                <div>
                  <label className="block text-[#94a3b8] text-sm mb-2">Imagen URL</label>
                  <input type="url" value={sector.image} onChange={(e) => handleSectorChange(index, "image", e.target.value)} className="contact-input w-full" />
                </div>
                {sector.image && (
                  <div className="h-24 bg-[#0b1221] border border-white/10 overflow-hidden">
                    <img src={sector.image} alt={sector.title} className="w-full h-full object-cover" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end">
          <button type="submit" disabled={saving} className="btn-primary flex items-center gap-2">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
            <span>{saving ? "Guardando..." : "Guardar Cambios"}</span>
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default SectorsEditor;
